import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import PageHero from '../components/ui/PageHero';
import './Contact.css';

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <>
      <Helmet>
        <title>Kontakt – TopCasinoDansk</title>
        <meta name="description" content="Kontakt redaktionen bag TopCasinoDansk. Vi besvarer spørgsmål om vores anmeldelser, metode og ansvarligt spil." />
      </Helmet>

      <PageHero
        title="Kontakt os"
        subtitle="Har du spørgsmål, rettelser eller feedback? Vores redaktion besvarer henvendelser inden for 2-3 hverdage."
        breadcrumb={<><Link to="/">Forside</Link> › Kontakt</>}
      />

      <section className="contact-section section">
        <div className="container">
          <div className="contact-grid">
            {/* Form */}
            <div className="contact-form-wrap">
              {submitted ? (
                <div className="contact-success">
                  <div className="contact-success-icon">✓</div>
                  <h3>Tak for din besked!</h3>
                  <p>Vi har modtaget din henvendelse og vender tilbage inden for 2-3 hverdage.</p>
                  <button className="btn btn-outline" onClick={() => setSubmitted(false)}>Send ny besked</button>
                </div>
              ) : (
                <>
                  <h2>Send en besked</h2>
                  <p className="contact-form-intro">
                    Udfyld formularen nedenfor. Vi svarer typisk inden for 2 hverdage.
                  </p>
                  <form className="contact-form" onSubmit={handleSubmit} noValidate>
                    <div className="form-row">
                      <div className="form-field">
                        <label htmlFor="name">Navn</label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          placeholder="Dit fulde navn"
                          value={form.name}
                          onChange={handleChange}
                          required
                          autoComplete="name"
                        />
                      </div>
                      <div className="form-field">
                        <label htmlFor="email">E-mail</label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          placeholder="din@email.dk"
                          value={form.email}
                          onChange={handleChange}
                          required
                          autoComplete="email"
                        />
                      </div>
                    </div>
                    <div className="form-field">
                      <label htmlFor="subject">Emne</label>
                      <select id="subject" name="subject" value={form.subject} onChange={handleChange} required>
                        <option value="">Vælg et emne</option>
                        <option value="redaktionel">Redaktionel henvendelse</option>
                        <option value="anmeldelse">Spørgsmål om en anmeldelse</option>
                        <option value="ansvarlig">Ansvarligt spil / hjælp</option>
                        <option value="affiliate">Affiliate / samarbejde</option>
                        <option value="andet">Andet</option>
                      </select>
                    </div>
                    <div className="form-field">
                      <label htmlFor="message">Besked</label>
                      <textarea
                        id="message"
                        name="message"
                        placeholder="Beskriv dit spørgsmål eller din henvendelse..."
                        rows={6}
                        value={form.message}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-disclaimer">
                      <p>
                        Din henvendelse behandles i overensstemmelse med vores{' '}
                        <Link to="/privatlivspolitik">privatlivspolitik</Link>.
                        Vi deler aldrig dine oplysninger med tredjepart.
                      </p>
                    </div>
                    <button type="submit" className="btn btn-primary">
                      Send besked
                    </button>
                  </form>
                </>
              )}
            </div>

            {/* Sidebar */}
            <aside className="contact-sidebar">
              <div className="contact-info-card">
                <h4>Redaktionel kontakt</h4>
                <p>For spørgsmål om vores anmeldelser, indhold eller redaktionelle metode.</p>
                <div className="contact-detail">
                  <span className="contact-detail-icon">✉️</span>
                  <span>redaktion@topcasinodansk.com</span>
                </div>
              </div>

              <div className="contact-info-card">
                <h4>Svartider</h4>
                <div className="contact-hours">
                  <div><span>Hverdage</span><span>Inden for 2 hverdage</span></div>
                  <div><span>Weekender</span><span>Inden for 3-4 hverdage</span></div>
                </div>
              </div>

              <div className="contact-safety-card">
                <h4>⚠️ Har du brug for hjælp til spil?</h4>
                <p>
                  Vi er en informationsportal og kan ikke yde personlig rådgivning om spilleproblemer.
                  Kontakt venligst disse professionelle tjenester:
                </p>
                <a href="https://www.stopspillet.dk/" target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-sm" style={{ marginBottom: '0.5rem', display: 'block', textAlign: 'center' }}>
                  StopSpillet.dk
                </a>
                <a href="https://www.rofus.nu/" target="_blank" rel="noopener noreferrer" className="btn btn-outline btn-sm" style={{ display: 'block', textAlign: 'center' }}>
                  ROFUS selvudelukkelse
                </a>
                <p className="contact-hotline">
                  <strong>Hjælpetelefon:</strong> 70 22 28 25 (StopSpillet)
                </p>
              </div>
            </aside>
          </div>
        </div>
      </section>
    </>
  );
}
